import React, { FC } from 'react';

import { Button, Modal } from '../../../../shared/ui';

interface IProtocolModalProps {
  isShow: boolean;
  onClose: () => void;
}

const ProtocolModal: FC<IProtocolModalProps> = ({ isShow, onClose }) => {
  return (
    <Modal
      isOpen={isShow}
      onClose={onClose}
      size="sm"
      title="Протоколы"
      footer={
        <Button size="md" variant="primary" fullWidth onClick={onClose}>
          Понятно
        </Button>
      }
    >
      <p className="text-ui text-ink-muted">Раздел находится в разработке. Мы сообщим, когда функция будет доступна.</p>
    </Modal>
  );
};

export default ProtocolModal;
